import { render, staticRenderFns } from "./VotingLimitRulesInfo.vue?vue&type=template&id=5a100c63&"
import script from "./VotingLimitRulesInfo.vue?vue&type=script&lang=js&"
export * from "./VotingLimitRulesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports